interface PostFbCustomConversionEventProps {
  id: string;
}

export const postFbCustomConversionEvent = (
  props: PostFbCustomConversionEventProps
) => {
  const { id } = props;
  fbq("init", id);
  fbq("track", "PageView");
};
